// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller
/* eslint-disable */

import { application } from "../application"

import AddressController from './address_controller.js'
application.register('address', AddressController)

import AjaxController from './ajax_controller.js'
application.register('ajax', AjaxController)

import ApplicationController from './application_controller.js'
application.register('application', ApplicationController)

import MapsPlacesController from './maps/places_controller.js'
application.register('maps--places', MapsPlacesController)

import MapsRoutesController from './maps/routes_controller.js'
application.register('maps--routes', MapsRoutesController)

import MenuController from './menu_controller.js'
application.register('menu', MenuController)

import ResizerController from './resizer_controller.js'
application.register('resizer', ResizerController)

import SecondaryZipcodesController from './secondary_zipcodes_controller.js'
application.register('secondary-zipcodes', SecondaryZipcodesController)

import SteppersController from './steppers_controller.js'
application.register('steppers', SteppersController)

import UtilController from './util_controller.js'
application.register('util', UtilController)

import ZipcodesController from './zipcodes_controller.js'
application.register('zipcodes', ZipcodesController)
